import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import './Blogs.css';

const Blogs = () => {
  const blogs = [
    {
      id: 1,
      title: 'New Fashion Arrival, Introducing The Skate Fashion 2024',
      excerpt: 'Dive into the world of everlasting elegance and fashion finesse with Chic Chronicles Skate Fashion Outfit that will arrive in 2024. Discover the latest trends and styles...',
      image: 'https://images.unsplash.com/photo-1490481651871-ab68de25d43d?w=800&h=600&fit=crop',
      date: 'January 10, 2026',
      category: 'Fashion Trends'
    },
    {
      id: 2,
      title: 'Wanderlust Wardrobe: Fashion from Every Corner of the Globe',
      excerpt: 'Embark on a sartorial journey around the world with Wanderlust Wardrobe. Explore fashion styles inspired by different cultures and regions...',
      image: 'https://images.unsplash.com/photo-1445205170230-053b83016050?w=800&h=600&fit=crop',
      date: 'January 8, 2026',
      category: 'Travel & Fashion'
    },
    {
      id: 3,
      title: 'Sustainable Fashion: The Future of Style',
      excerpt: 'Learn about eco-friendly fashion choices and how sustainable practices are shaping the future of the fashion industry...',
      image: 'https://images.unsplash.com/photo-1441984904996-e0b6ba687e04?w=800&h=600&fit=crop',
      date: 'January 5, 2026',
      category: 'Sustainability'
    },
    {
      id: 4,
      title: 'Street Style Essentials for 2026',
      excerpt: 'Discover the must-have pieces for your street style wardrobe this year. From basics to statement pieces...',
      image: 'https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?w=800&h=600&fit=crop',
      date: 'January 3, 2026',
      category: 'Street Style'
    },
    {
      id: 5,
      title: 'The Art of Layering: Winter Fashion Guide',
      excerpt: 'Master the art of layering with our comprehensive guide to staying stylish and warm during the colder months...',
      image: 'https://images.unsplash.com/photo-1487222477894-8943e31ef7b2?w=800&h=600&fit=crop',
      date: 'December 28, 2025',
      category: 'Styling Tips'
    },
    {
      id: 6,
      title: 'Accessorizing 101: Complete Your Look',
      excerpt: 'Learn how to choose the perfect accessories to complement your outfit and express your personal style...',
      image: 'https://images.unsplash.com/photo-1496217590455-aa63a8350eea?w=800&h=600&fit=crop',
      date: 'December 25, 2025',
      category: 'Accessories'
    }
  ];

  return (
    <div className="blogs-page">
      <div className="blogs-container">
        <div className="blogs-header">
          <Link to="/" className="back-link">
            <FiArrowLeft size={20} />
            Back to Home
          </Link>
          <h1>Read Super Blog.</h1>
          <p>Dive into a sea of stylish outfits that promise to impress and delight with their cool and trendy selections.</p>
        </div>

        <div className="blogs-grid">
          {blogs.map((blog) => (
            <article key={blog.id} className="blog-card">
              <div className="blog-image">
                <img src={blog.image} alt={blog.title} />
                <span className="blog-category">{blog.category}</span>
              </div>
              <div className="blog-content">
                <time className="blog-date">{blog.date}</time>
                <h2>{blog.title}</h2>
                <p>{blog.excerpt}</p>
                <Link to={`/blogs/${blog.id}`} className="read-more">
                  Read More →
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Blogs;
